import { useNavigate, useLocation } from 'react-router-dom'
import { House, Map, Radio, Bookmark, User } from 'lucide-react'

const C = { teal: '#0F5C5C', live: '#D85F5F', ink2: '#6D7471' }
const FB = "'Inter', sans-serif"

const NAV = [
  { path: '/', icon: House, label: 'Inicio' },
  { path: '/map', icon: Map, label: 'Mapa' },
  { path: '/now', icon: Radio, label: 'Ahora', center: true },
  { path: '/saved', icon: Bookmark, label: 'Guardados' },
  { path: '/profile', icon: User, label: 'Perfil' },
]

export default function BottomNav() {
  const navigate = useNavigate()
  const { pathname } = useLocation()

  const isActive = (path: string) => (path === '/' ? pathname === '/' : pathname.startsWith(path))

  return (
    <nav className="bottom-nav">
      {NAV.map(({ path, icon: Icon, label, center: _center }) => {
        const active = isActive(path)
        const isNow = path === '/now'

        return (
          <button
            key={path}
            onClick={() => navigate(path)}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 4,
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
              flex: 1,
              padding: '4px 0',
            }}
          >
            {isNow ? (
              <div
                style={{
                  width: 46,
                  height: 34,
                  borderRadius: 12,
                  background: active ? C.live : C.teal,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow: '0 4px 12px rgba(15,92,92,.3)',
                  position: 'relative',
                }}
              >
                <Icon size={20} color="#fff" />
                <span
                  style={{
                    position: 'absolute',
                    top: 4,
                    right: 6,
                    width: 6,
                    height: 6,
                    borderRadius: 99,
                    background: '#fff',
                    animation: 'pxPulse 1.5s infinite',
                  }}
                />
              </div>
            ) : (
              <Icon size={22} color={active ? C.teal : C.ink2} />
            )}
            <span
              style={{
                fontSize: 10.5,
                fontWeight: active ? 700 : 500,
                fontFamily: FB,
                color: isNow ? (active ? C.live : C.teal) : active ? C.teal : C.ink2,
              }}
            >
              {label}
            </span>
          </button>
        )
      })}
    </nav>
  )
}
